import { render, staticRenderFns } from "./Heading4.vue?vue&type=template&id=d60c485e&"
import script from "./Heading4.vue?vue&type=script&lang=js&"
export * from "./Heading4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports